import {Toast} from 'component';
import {QueryClient} from '@tanstack/react-query';

import {strings} from 'asset/constant';

const networkErrorStatusCode = 'ERR_NETWORK';

const handleQueryError = (error: any) => {
  if (error.code !== networkErrorStatusCode) {
    Toast.error({
      message: error?.response?.data?.message ?? strings?.retry,
    });
  }
};

const handleMutationError = (error: any) => {
  if (error.code !== networkErrorStatusCode) {
    Toast.error({
      message: error?.response?.data?.message ?? strings?.retry,
    });
  } else {
    Toast.error({
      message: strings.connection_error,
    });
  }
};

const client = new QueryClient({
  defaultOptions: {
    queries: {
      onError(err) {
        handleQueryError(err);
      },
    },
    mutations: {
      onError(err) {
        handleMutationError(err);
      },
    },
  },
});

export default client;
